module.exports = __webpack_public_path__ + "img/nextgen-logo.68933c6f.png";